import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import {
  FacebookIcon,
  InstagramIcon,
  LinkedinBlankIcon,
  TwitterIcon,
  YoutubeIcon,
} from 'src/assets/icons'
import { SocialInput } from './social-input.component'

import { useStyles } from './styles'
import { ETranslationNs, IAccountFormCreate } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

const Socials = () => {
  const [t] = useTranslation(ETranslationNs.Form)
  const { values, handleChange } = useFormikContext<IAccountFormCreate>()
  const classes = useStyles()

  return (
    <Grid className={classes.bigContainer}>
      <div className={classes.text}>
        <HelperWrapper t="account-form-socials-label" />
      </div>
      <Grid className={classes.selectionsWrapper}>
        <SocialInput
          inputIcon={<FacebookIcon />}
          inputName="socials.facebook"
          value={values.socials?.facebook}
          handleChange={handleChange}
          inputPlaceholder={t('account-socials-facebook-input-placeholder.v')}
        />
        <SocialInput
          inputIcon={<InstagramIcon />}
          inputName="socials.instagram"
          value={values.socials?.instagram}
          handleChange={handleChange}
          inputPlaceholder={t('account-socials-instagram-input-placeholder.v')}
        />
        <SocialInput
          inputIcon={<TwitterIcon />}
          inputName="socials.x"
          value={values.socials?.x}
          handleChange={handleChange}
          inputPlaceholder={t('account-socials-x-input-placeholder.v')}
        />
        <SocialInput
          inputIcon={<LinkedinBlankIcon />}
          inputName="socials.linkedin"
          value={values.socials?.linkedin}
          handleChange={handleChange}
          inputPlaceholder={t('account-socials-linkedin-input-placeholder.v')}
        />
        <SocialInput
          inputIcon={<YoutubeIcon />}
          inputName="socials.youtube"
          value={values.socials?.youtube}
          handleChange={handleChange}
          inputPlaceholder={t('account-socials-youtube-input-placeholder.v')}
        />
      </Grid>
    </Grid>
  )
}
export { Socials }
